import { useEffect } from "react";

const GA_ID = "G-HDHCRM4X2F";

export default function GoogleAnalytics() {

    useEffect(() => {
        const loadAnalytics = () => {
            // Prevent duplicate loading
            if (window.gtagLoaded) return;

            window.dataLayer = window.dataLayer || [];
            window.gtag = function () {
                window.dataLayer.push(arguments);
            };

            window.gtag("consent", "default", {
                analytics_storage: "granted",
                ad_storage: "denied",
                ad_user_data: "denied",
                ad_personalization: "denied"
            });

            const script = document.createElement("script");
            script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
            script.async = true;

            script.onload = () => {
                window.gtag("js", new Date());
                window.gtag("config", GA_ID, { anonymize_ip: true });
                window.gtagLoaded = true;
            };
            document.head.appendChild(script);
        };

        // Load after browser is idle
        if ("requestIdleCallback" in window) {
            window.requestIdleCallback(loadAnalytics);
        } else {
            setTimeout(loadAnalytics, 3000);
        }
    }, []);

    return null;
}